import { Component, OnInit } from "@angular/core";
import {
    BaseComponent, UserService,
} from "@rubii/frontend-common";

@Component({
    selector: "app-datasources",
    templateUrl: "./datasources.component.html",
    styleUrls: ["./datasources.component.scss"],
})
export class DatasourcesComponent extends BaseComponent implements OnInit {
    constructor(
        public userService: UserService,
    ) {
        super();
    }

    async ngOnInit(): Promise<void> {
    }
}
